module.exports = __webpack_public_path__ + "static/media/vehicle.1a7cbd73.svg";